import { useContext } from "react";
import { UserIdContext } from "./user-id-context";

export const useUserIdContext = () => {
    const context = useContext(UserIdContext);
    if (context === undefined) {
        throw new Error(
            "useUserIdContext must be used within a UserIdProvider"
        );
    }
    return context;
};
